export default __webpack_public_path__ + "static/media/location_green_pin.7bb7b537.png";